import { render, staticRenderFns } from "./SubHireApprovedList.vue?vue&type=template&id=6fdd6232"
import script from "./SubHireApprovedList.vue?vue&type=script&lang=js"
export * from "./SubHireApprovedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports